import { render, staticRenderFns } from "./CampaignUser.vue?vue&type=template&id=0343fab8&scoped=true"
import script from "./CampaignUser.vue?vue&type=script&lang=js"
export * from "./CampaignUser.vue?vue&type=script&lang=js"
import style0 from "./CampaignUser.vue?vue&type=style&index=0&id=0343fab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0343fab8",
  null
  
)

export default component.exports